import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { FullScreenDialog } from '../components/common/FullScreenDialog';
import { Loading } from '../components/common/Loading';
import { Stack } from '../components/common/Stack';

function getStoreUrlByPlatform() {
  const userAgent = navigator.userAgent;

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return import.meta.env.VITE_IOS_APP_STORE_URL;
  }

  if (/Android/.test(userAgent)) {
    return import.meta.env.VITE_ANDROID_PLAY_STORE_URL;
  }

  return '/login';
}

function openAppWithStoreFallback(appUrl: string, fallbackUrl: string) {
  window.location.replace(appUrl);

  window.setTimeout(() => {
    window.location.replace(fallbackUrl);
  }, 1500);
}

export function VerifyEmail() {
  const { token } = useParams();

  useEffect(() => {
    if (!token) {
      window.location.replace('/login');
      return;
    }

    const appDeepLinkBase = import.meta.env.VITE_MOBILE_APP_DEEPLINK;

    if (!appDeepLinkBase) {
      window.location.replace('/login');
      return;
    }

    const appDeepLink = `${appDeepLinkBase}?token=${encodeURIComponent(token)}`;

    const storeFallback = getStoreUrlByPlatform() ?? '/login';

    openAppWithStoreFallback(appDeepLink, storeFallback);
  }, [token]);

  return (
    <FullScreenDialog>
      <Stack>
        <Loading />
      </Stack>
    </FullScreenDialog>
  );
}
